import { CbhFeatureFlag } from "./CbhFeatureFlag";
import { useCbhFlag } from "./useCbhFlag";

const DEFAULT_FAVORITE_WORKPLACES_CONFIG = {
  enabled: false,
  maxFavoriteCount: 2,
  clipboardScoreThreshold: 250,
  shiftDiscoveryWindowInDays: 365,
} as const;

export function useFavoriteWorkplacesFlag() {
  return useCbhFlag(CbhFeatureFlag.ENABLE_FAVORITE_WORKPLACES, {
    defaultValue: DEFAULT_FAVORITE_WORKPLACES_CONFIG,
  });
}
